export interface SummaryQuote {
  date: string;
  pct: number;
  chg: number;
  price: number;
};

export interface PerfSummaryQuote {
  oneMonth?: SummaryQuote;
  threeMonths?: SummaryQuote;
  oneYear?: SummaryQuote;
  yearToDate?: SummaryQuote;
  now?: SummaryQuote;
  endOfDay?: SummaryQuote;
  oneWeek?: SummaryQuote;
  sixMonths?: SummaryQuote;
};

export interface CompanyInfo {
  lastEarnings: string;
  symbol: string;
  name: string;
  nextEarnings: string;
  exchange: string;
  industry: string;
  sector: string;
  hasOptions: boolean;
  baseSymbol: string;
};

export interface JsonLayerSymbolSummary {
  symbol: string;
  dividendRateForecast: number | null;
  sectorSymbol: string | null;
  rsi: number | null;
  dividendYield: number | null;
  quoteYesterdayClose: number | null;
  atr: number | null;
  perfSummaryQuote: PerfSummaryQuote | null;
  dividendYieldForecast: number | null;
  quoteLow: number | null;
  sma200: number | null;
  marketCap: number | null;
  sma50: number | null;
  intradayVolume: number | null;
  smaVol: number | null;
  companyInfo: CompanyInfo | null;
  eps: number | null;
  dividendRate: number | null;
  quoteHigh: number | null;
  quoteVolume: number | null;
  pctList: number[] | null;
  chgList: number[] | null;
  nextEarningsDate: string | null;
  adx: number | null;
  earningsTime: string | null;
  pe: number | null;
  ema20: number | null;
  universe: string | null;
  dividendExDate: string | null;
  sctr: number | null;
  lastEarningsDate: string | null;
  intradayDate: string | null;
  intradayClose: number | null;
  quoteClose: number | null;
  quoteOpen: number | null;
};

export function isJsonLayerSymbolSummary(unknownValue: unknown): unknownValue is JsonLayerSymbolSummary {
  return (
    typeof unknownValue === 'object' &&
    unknownValue !== null &&
    'symbol' in unknownValue &&
    typeof unknownValue.symbol === 'string' // TODO: check for remaining types all of optional and all required properties here
  );
}
